// frontend/admin-portal/src/components/products/ProductCategoryBadge.jsx
import React from "react";
import { Badge } from "@fiberhome/shared-ui";

const KIND_VARIANT = {
  passive: "info",
  cable: "warning",
  active: "primary",
  instrument: "success",
  accessory: "default",
};

export default function ProductCategoryBadge({ category }) {
  if (!category) return null;
  return (
    <Badge variant={KIND_VARIANT[category.kind] || "default"}>
      {category.name}
    </Badge>
  );
}
